<div class="app-header container__fluid">
  <div class="logo">
    &nbsp;
  </div>
  <ul class="app-menu">
    <li class="app-menu_item"><a [routerLink]="'/app/dashboard' | localize" routerLinkActive="active">{{'app.appHeader.li4' | translate}}</a></li>
    <li class="app-menu_item"><a [routerLink]="'/app/devices' | localize" routerLinkActive="active">{{'app.appHeader.li1' | translate}}</a></li>
    <li class="app-menu_item"><a [routerLink]="'/app/media' | localize" routerLinkActive="active">{{'app.appHeader.li2' | translate}}</a></li>
    <li class="app-menu_item"><a [routerLink]="'/app/schedule' | localize" routerLinkActive="active">{{'app.appHeader.li3' | translate}}</a></li>
  </ul>
  <div class="control-btns">
    <button *ngIf="isMarketplaceMode" type="button" class="dw-btn marketplace-btn" [routerLink]="'/marketplace' | localize">DWall Market</button>
    <button class="dw-subscribe"
            [routerLink]="'/app/user/subscribe' | localize"
            *ngIf="isSubscription$() | async"
    >{{'app.appHeader.button' | translate}}</button>
    <div class="lang">
      <ng-select
              [ngModel]="lang"
              [items]="languages"
              bindValue="value"
              [searchable]="false"
              [clearable]="false"
              (ngModelChange)="setLang($event)"
      >
        <ng-template ng-label-tmp let-item="item">
          {{'landing.header.lang.' + item.value | translate | slice: 0: 3 }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{'landing.header.lang.' + item.value | translate }}
        </ng-template>
      </ng-select>
    </div>
    <div class="user">
      <span class="user-icon">
        <i class="hgi hgi-stroke hgi-user-02"></i>
      </span>
      <div class="user-menu">
        <a
          *ngIf="'read' | able: 'Settings' else security"
          [routerLink]="'/app/user' | localize"
        >{{'app.common.settings' | translate}}</a>
        <a href="#" (click)="logout();$event.preventDefault();">{{'app.myAccount.logout' | translate}}</a>
          <ng-template #security>
            <a [routerLink]="'/app/user/security' | localize">{{'app.myAccount.security' | translate}}</a>
          </ng-template>
      </div>
    </div>
  </div>
</div>
